import { PartialDoctorSignature } from "../../partials/doctorSignature";
import { PartialResponsibleSignature } from "../../partials/responsibleSignature";

export const examinationRequest = {
  name: "Solicitação de exame",
  title:
    "Solicitação de Exame",
  gender: "female",
  fields: {
    exam: {
      label: "Exame Solicitado",
      type: "text",
      required: true,
      defaultPreview: _.range(20).fill("_").join(""),
    },
    microchip: {
      label: "Nº Microchip",
      type: "text",
      required: false,
    },
  },
  partials: {
    doctorSignature: {
      defaultValue: true,
      partial: PartialDoctorSignature,
    },
    responsibleSignature: {
      defaultValue: true,
      partial: PartialResponsibleSignature,
    },
  },
  content: `
   <p>Solicito {{exam}} para o animal identificado neste documento{{#microchip}}, nº do microchip: <span>{{microchip}}</span>{{/microchip}}.</p>
    {{#doctorSignature}}
      <br />
      <br />
      <br />
      <br />
      <br />
      {{>doctorSignature}}
    {{/doctorSignature}}
  `.trim(),
};
